import { render, staticRenderFns } from "./icon-point.vue?vue&type=template&id=62166420&scoped=true&"
import script from "./icon-point.vue?vue&type=script&lang=js&"
export * from "./icon-point.vue?vue&type=script&lang=js&"
import style0 from "./icon-point.vue?vue&type=style&index=0&id=62166420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62166420",
  null
  
)

export default component.exports